import {
  AmountCell,
  Badge,
  ClipboardDocumentListIcon,
  formatTimeDate,
  NameCell,
  PhoneCell,
  SubduedCell,
  success,
} from "@";

const copyLink = (link) => {
  navigator.clipboard.writeText(link);
  success("تم نسخ الرابط");
};

// Affiliate referral link — small click-to-copy chip
const AffiliateLinkCell = ({ link }) => {
  if (!link) {
    return <span className="text-xs text-gray-300 dark:text-gray-600">—</span>;
  }
  return (
    <button
      type="button"
      onClick={() => copyLink(link)}
      title={link}
      className="inline-flex max-w-[260px] items-center gap-1.5 truncate rounded-full bg-purple-50 px-2.5 py-1 text-[11px] font-medium text-purple-900 ring-1 ring-purple-100 transition-colors hover:bg-purple-100 dark:bg-purple-950/40 dark:text-purple-300 dark:ring-purple-800/40 dark:hover:bg-purple-900/40"
    >
      <ClipboardDocumentListIcon className="h-3.5 w-3.5 shrink-0" />
      <span className="truncate">{link}</span>
    </button>
  );
};

// Donor — name (bold) above phone (mono) so each row reads as a person
const DonorCell = ({ name, phone }) => (
  <div className="flex flex-col leading-tight">
    <NameCell name={name} />
    <PhoneCell phone={phone} />
  </div>
);

// DateTime — feature uses time-aware formatter
const DateTimeCell = ({ value }) => (
  <span className="text-sm tabular-nums text-gray-700 dark:text-gray-300">
    {value ? formatTimeDate(value) : "—"}
  </span>
);

// TanStack column defs
const tableColumns = [
  {
    id: "affiliateName",
    header: "اسم المعلن",
    size: 180,
    cell: ({ row }) => <NameCell name={row.original.affiliateName} />,
  },
  {
    id: "affiliateLink",
    header: "الرابط",
    size: 280,
    cell: ({ row }) => <AffiliateLinkCell link={row.original.affiliateLink} />,
  },
  {
    id: "donor",
    header: "المتبرع",
    size: 200,
    cell: ({ row }) => (
      <DonorCell
        name={row.original.donorName}
        phone={row.original.phoneNumber}
      />
    ),
  },
  {
    id: "totalAmount",
    header: "المبلغ",
    size: 120,
    cell: ({ row }) => (
      <AmountCell value={row.original.totalAmount} tone="emerald" />
    ),
  },
  {
    id: "paymentType",
    header: "وسيلة التبرع",
    size: 120,
    cell: ({ row }) => (
      <Badge
        title={row.original.paymentType === 0 ? "بطاقة" : "تحويل بنكي"}
        color={row.original.paymentType === 0 ? "default" : "dark"}
      />
    ),
  },
  {
    id: "isPaid",
    header: "الحالة",
    size: 110,
    cell: ({ row }) => (
      <Badge
        title={row.original.isPaid ? "مدفوعة" : "غير مدفوعة"}
        color={row.original.isPaid ? "green" : "red"}
      />
    ),
  },
  {
    id: "bankAccountName",
    header: "البنك",
    size: 160,
    cell: ({ row }) => <SubduedCell value={row.original.bankAccountName} />,
  },
  {
    id: "createdOn",
    header: "التاريخ",
    size: 150,
    cell: ({ row }) => <DateTimeCell value={row.original.createdOn} />,
  },
];

export default tableColumns;
